import { PropertySetModule } from '@/services/admin/property-set/modal'
import { Dimension } from '@/services/dimension/dimension.model'
import { CaseModal } from '@/services/project/cases.service'
import { SimulationModal } from '@/services/project/simulation.service'
import { UnitSet } from '@/services/unitSet/unitSet.model'
import { createSlice } from '@reduxjs/toolkit'
import { getActiveUnitSetThunk, getProjectCasesThunk, getProjectPropertySetsThunk, getProjectSimulationsThunk, loadDimensionsThunk } from './actions'
import { RootState } from '..'

export interface ProjectState {
  cases: CaseModal[],
  simulations: SimulationModal[],
  propertySets: PropertySetModule.Modal[],
  unitSet?: UnitSet,
  dims: Dimension.Info[]
  isLoading: boolean
}


const initialState: ProjectState = {
  cases: [],
  simulations: [],
  propertySets: [],
  dims: [],
  isLoading: false
}



export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectCasesThunk.fulfilled, (state, action) => {
      state.cases = action.payload;
    })
    builder.addCase(getProjectPropertySetsThunk.fulfilled, (state, action) => {
      state.propertySets = action.payload;
    })
    builder.addCase(getProjectSimulationsThunk.fulfilled, (state, action) => {
      state.simulations = action.payload;
    })
    builder.addCase(getActiveUnitSetThunk.fulfilled, (state, action) => {
      state.unitSet = action.payload;
    })
    builder.addCase(loadDimensionsThunk.fulfilled, (state, action) => {
      state.dims = action.payload;
    })
  }
})

export function getPropertySets(state: RootState) {
  return state.project.propertySets
}


